export const SET_IS_AUTHENTICATED = 'set_is_authenticated'
